const toHalfLetter = (str: string): string => {
  let output = '';
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code === 12288) {
      // 전각 공백을 반각  공백으로 변환
      output += String.fromCharCode(32);
    } else if (code > 65280 && code < 65375) {
      // 전각 문자를 반각 문자로 변환
      output += String.fromCharCode(code - 65248);
    } else {
      output += String.fromCharCode(code);
    }
  }
  return output;
};

export default toHalfLetter;
